import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.UserEmployeeValidation = function () {
        const dictonary = {
            custom: {
                userId: {
                    required: () => t.t(dictEnum.LBL_ID) + t.t(dictEnum.WARN_IsRequired)
                },
                pass: {
                    is: () => t.t(dictEnum.WARN_PasswordNotMatch),
                    required: () =>
                        t.t(dictEnum.LBL_Password) + t.t(dictEnum.WARN_IsRequired)
                },
                newPass: {
                    is: () => t.t(dictEnum.WARN_PasswordNotMatch),
                    required: () =>
                        t.t(dictEnum.LBL_ConfirmNewPw) + t.t(dictEnum.WARN_IsRequired)
                },
                language: {
                    required: () =>
                        t.t(dictEnum.LBL_Language) + t.t(dictEnum.WARN_IsRequired)
                },
                UserGrps: {
                    required: () =>
                        t.t(dictEnum.LBL_UserGrp) + t.t(dictEnum.WARN_IsRequired)
                },
                pass: {
                    is: () => t.t(dictEnum.WARN_PasswordNotMatch),
                    required: () =>
                        t.t(dictEnum.LBL_Password) + t.t(dictEnum.WARN_IsRequired)
                },
                newPass: {
                    is: () => t.t(dictEnum.WARN_PasswordNotMatch),
                    required: () =>
                        t.t(dictEnum.LBL_ConfirmNewPw) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/UserEmployee/UserEmployeeValidation.js